<template>
  <el-form
    ref="form"
    :model="formData"
    :rules="rules"
    :disabled="disabled"
    label-position="top"
  >
    <div class="side-frame group-title">
      <span>基本信息</span>
      <el-divider direction="vertical"></el-divider>
      <span
        >状态：{{
          formData.contractStatusName ? formData.contractStatusName : '新增'
        }}</span
      >
    </div>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item label="合同编号">
          <el-input
            clearable
            v-model="formData.contractNo"
            placeholder="系统自动生成"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item label="合同名称" prop="contractName">
          <el-input
            clearable
            v-model="formData.contractName"
            placeholder="请输入合同名称"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="客户名称" prop="custCode">
          <dict-select
            v-model="formData.custCode"
            url="/master/customer/info/select"
            placeholder="请选择客户"
            filterable
            clearable
          ></dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="运输模式" prop="transportMode">
          <dict-select
            v-model="formData.transportMode"
            placeholder="请选择运输模式"
            style="width: 100%"
            default
            filterable
            clearable
            :body="transportModeDictParams"
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="计费单位" prop="chargeUnit">
          <dict-select
            v-model="formData.chargeUnit"
            placeholder="请选择计费单位"
            style="width: 100%"
            default
            filterable
            clearable
            :body="chargeUnitDictParams"
            @change="(val) => $emit('chargeUnitChangeChange', val)"
            :disabled="isEditStatus"
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="结算方式" prop="settlementMethod">
          <dict-select
            v-model="formData.settlementMethod"
            placeholder="请选择结算方式"
            style="width: 100%"
            default
            filterable
            clearable
            :body="settlementMethodDictParams"
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="formData.startDate"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="请选择开始日期"
            style="width: 100%"
            @change="cacalDays"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="formData.endDate"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="请选择结束日期"
            style="width: 100%"
            @change="cacalDays"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="有效期天数" prop="validDays">
          <el-input-number
            clearable
            v-model="formData.validDays"
            style="width: 100%"
            controls-position="right"
            @blur="cacalDate"
          >
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="重泡属性" prop="weightType">
          <el-select
            v-model="formData.weightType"
            placeholder="请选择重泡属性"
            style="width: 100%"
            clearable
          >
            <el-option label="重货" value="A" />
            <el-option label="重泡货" value="B" />
            <el-option label="轻泡货" value="C" />
            <el-option label="泡货" value="D" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否启用重泡比" prop="useTransWeight">
          <el-radio-group
            v-model="formData.useTransWeight"
            style="width: 100%"
            @change="onUseTransWeightChange"
          >
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="重泡比(1立方米等于多少千克)"
          prop="useTransWeightRatio"
        >
          <el-input-number
            clearable
            v-model="formData.useTransWeightRatio"
            placeholder="请输入重泡比"
            :step="1"
            style="width: 100%"
            controls-position="right"
            :max="9999999"
            :disabled="disabledUseTransWeightRatio"
          >
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="保留小数位数" prop="numberDecimal">
          <el-input-number
            clearable
            v-model="formData.numberDecimal"
            placeholder="请输入位数"
            style="width: 100%"
            controls-position="right"
            :max="4"
          >
          </el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="进位方式" prop="roundingMethod">
          <el-select
            v-model="formData.roundingMethod"
            placeholder="请选择进位方式"
            style="width: 100%"
            clearable
          >
            <el-option label="四舍五入" value="A" />
            <el-option label="去尾法" value="B" />
            <el-option label="进一法" value="C" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="side-frame-success group-title">指派机构</div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="组织机构" prop="orgCode">
          <org-cascader
            filterable
            style="width: 100%"
            :lastValue.sync="formData.orgCode"
            :valueString.sync="formData.orgCodeList"
            :props="{ multiple: false }"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import validate from '@/libs/util.validate'
import dayjs from '@/libs/util.date'
export default {
  props: {
    code: String,
    disabled: Boolean,
    isEditStatus: Boolean,
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (!this.formData.startDate || !this.formData.endDate) {
        callback()
        return
      }
      const validDays = dayjs(this.formData.endDate).diff(
        this.formData.startDate,
        'day'
      )
      if (validDays < 0) {
        callback(new Error('结束日期不能小于开始日期'))
      } else {
        callback()
      }
    }
    return {
      chargeUnitDictParams: { type: 'chargeUnit' },
      transportModeDictParams: { type: 'transportMode' },
      settlementMethodDictParams: { type: 'settlementMethod' },
      formData: {
        startDate: '',
        orgCode: '',
        endDate: '',
        useTransWeight: 'N',
        numberDecimal: 2,
      },
      rules: {
        contractName: [
          { required: true, message: '请输入合同名称', trigger: 'blur' },
        ],
        custCode: [
          { required: true, message: '请选择客户', trigger: 'change' },
        ],
        transportMode: [
          { required: true, message: '请选择运输模式', trigger: 'change' },
        ],
        startDate: [
          {
            required: true,
            message: '请选择开始时间',
            trigger: 'change',
          },
          {
            message: '开始时间不能大于结束时间',
            trigger: 'change',
            validator: validateDate,
          },
        ],
        endDate: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          {
            message: '结束时间不能小于开始时间',
            trigger: 'change',
            validator: validateDate,
          },
        ],
        chargeUnit: [
          { required: true, message: '请选择计费单位', trigger: 'change' },
        ],
        orgCode: [
          { required: true, message: '请选择组织机构', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    'formData.validDays'() {
      if (this.formData.startDate) {
        let rdate =
          Math.abs(new Date(this.formData.startDate)) +
          this.formData.validDays * 24 * 60 * 60 * 1000
        this.formData.endDate = this.DateToString(new Date(rdate))
      }

      if (this.formData.endDate) {
        let rdate =
          Math.abs(new Date(this.formData.endDate)) -
          this.formData.validDays * 24 * 60 * 60 * 1000
        this.formData.startDate = this.DateToString(new Date(rdate))
      }
    },
  },
  computed: {
    disabledUseTransWeightRatio() {
      return this.formData.useTransWeight !== 'Y'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    DateToString(rdate) {
      let year = rdate.getFullYear()
      let month = rdate.getMonth() + 1
      if (month < 10) month = '0' + month
      let date = rdate.getDate()
      if (date < 10) date = '0' + date
      return year + '-' + month + '-' + date
    },
    getData() {
      if (!this.code) return
      this.$api
        .customerContractDetailApi({
          contractCode: this.code,
        })
        .then((res) => {
          this.formData = res.body || {}
          this.$emit('chargeUnitChange', this.formData.chargeUnit)
        })
    },
    onUseTransWeightChange(val) {
      if (val === 'N') {
        this.formData.useTransWeightRatio = ''
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return Promise.reject()
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      return this.$api
        .customerContractSavelApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.formData.contractCode = res.body
          return res.body
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cacalDays() {
      if (this.formData.startDate && this.formData.endDate) {
        const validDays = dayjs(this.formData.endDate).diff(
          this.formData.startDate,
          'day'
        )
        this.formData.validDays = validDays < 0 ? 0 : validDays
      }
    },
    cacalDate() {
      if (!this.formData.startDate) return
      this.formData.endDate = dayjs(this.formData.startDate)
        .add(this.formData.validDays, 'day')
        .format('YYYY-MM-DD')
    },
  },
}
</script>
